<template>
  <v-card class="v-verification text-center">
    <v-card-title>
      <v-row justify="center">
        <LeadtributorCloudIconColor/>
      </v-row>
    </v-card-title>
    <v-card-subtitle>
      <h1>{{ $t('login.verificationTitle') }}</h1>
    </v-card-subtitle>
    <div class="description pb-5">{{ $t('login.verificationDescription') }}</div>
    <div>
      <MailIconLg/>
    </div>
    <v-card-text class="text-left pt-5 pb-2 px-0">
      <slot name="privacy"></slot>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-text class="px-0 pb-0">
      <v-row
        align="center"
        justify="space-around"
      >
        <slot></slot>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import LeadtributorCloudIconColor from '@/components/icons/LeadtributorCloudIconColor'
import MailIconLg from '@/components/icons/MailIconLg'

export default {
  name: 'VerificationComponent',
  components: {
    MailIconLg,
    LeadtributorCloudIconColor
  }
}
</script>

<style scoped lang="scss">
.v-verification {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  padding: 24px 32px 32px;
  margin: 0 auto;
  max-width: 338px;

  .v-card__subtitle {
    margin-top: 32px;
  }

  h1 {
    color: #3E4041;
    font-size: 30px;
    font-weight: 300;
    line-height: 38px;
  }

  .description {
    color: #8EA2A8;
    font-size: 18px;
    line-height: 22px;
    margin-bottom: 32px;
  }

  .v-divider {
    margin-top: auto;
  }

  .v-card__text {
    color: #8EA2A8;
    font-size: 14px;
    line-height: 17px;
  }
}
</style>

<!-- global style to override framework styling  -->
<style lang="scss">
  .v-application .v-verification .v-card__text a {
    color: #8EA2A8;
    text-decoration: underline;
  }
</style>
